import React, { FC } from 'react';
import Form from 'components/Form';

import { MediqttoPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Mediqtto: FC<MediqttoPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Mediqtto;
